import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { EmailReply } from '../../views/email/EmailTypes';
import EmailMessageViewer from './EmailMessageViewer';
import '../../style/scss/timeline.scss';

interface EmailReplyViewerProps {
    reply: EmailReply;
    mode: 'modal' | 'inline';
    receivedDate?: string;
}

const EmailReplyViewer: React.FC<EmailReplyViewerProps> = ({
    reply,
    mode,
    receivedDate,
}) => {
    const { t } = useTranslation();
    const shadowRootRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (shadowRootRef.current) {
            const html = reply.body || '';

            if (shadowRootRef.current.shadowRoot) {
                shadowRootRef.current.shadowRoot.innerHTML = html;
            } else {
                const shadowRoot = shadowRootRef.current.attachShadow({ mode: 'open' });
                shadowRoot.innerHTML = html;
            }
        }
    }, [reply.body]);

    return (
        <div className='email-viewer'>
            {reply.message && (
                <div style={{ marginBottom: '1rem' }}>
                    <p className='helper-text'>{t('timeline.email_reply.general.original_message_label')}</p>
                    <EmailMessageViewer
                        email={reply.message}
                        mode="inline"
                        collapsed
                    />
                </div>
            )}

            <div className="email-header">
                <p>{t('email.general.from_short_label')}: {reply.from_name ? `${reply.from_name} <${reply.from_email}>` : reply.from_email}</p>
                {reply.subject && (
                    <p>{t('email.general.subject_label')}: {reply.subject}</p>
                )}
            </div>

            <div className='email-html-preview'>
                <div ref={shadowRootRef} />
            </div>

            {mode === "modal" && receivedDate && (
                <div className="email-footer">
                    <span>{receivedDate}</span>
                </div>
            )}
        </div>
    );
};

export default EmailReplyViewer;
